import React from 'react';


export default class Flip extends React.Component {
  render() {
    const { x, y, height } = this.props;
    return (
      <g
        style={{
          transform: `translate(${x}pt,${y}pt)`,
        }}
      >
        <g
          style={{ transform: `rotate(-180deg) translate(0pt, -${height}pt)` }}
        >
          <g
            style={{
              transform: `translate(${-x}pt,${-y}pt)`,
            }}
          >
            {this.props.children}
          </g>
        </g>
      </g>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Configuration/Render/SVG/flip.js